/**
 * TanStack Query hooks for `localized-help-center-intercom-backed`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	localizedHelpCenterIntercomBackedQueryKeys,
	type CreateLocalizedHelpCenterIntercomBackedBody,
	type ListLocalizedHelpCenterIntercomBackedResponse,
	type LocalizedHelpCenterIntercomBackedRow,
} from "./api";

export function useLocalizedHelpCenterIntercomBackedList(): UseQueryResult<ListLocalizedHelpCenterIntercomBackedResponse, Error> {
	return useQuery({
		queryKey: localizedHelpCenterIntercomBackedQueryKeys.list(),
		queryFn: list,
	});
}

export function useLocalizedHelpCenterIntercomBackedCreate(): UseMutationResult<LocalizedHelpCenterIntercomBackedRow, Error, CreateLocalizedHelpCenterIntercomBackedBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: localizedHelpCenterIntercomBackedQueryKeys.all });
		},
	});
}

export function useLocalizedHelpCenterIntercomBackedDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: localizedHelpCenterIntercomBackedQueryKeys.all });
		},
	});
}
